import { useMemo } from "react";
import { Product, ProductPrice } from "src/api/types";

export const useExtractForm = (
  price: ProductPrice | null,
  product: Product | null,
) => {
  const form = useMemo(() => {
    if (product?.category.name !== "Hair Loss") return undefined;

    return price?.name.split(" ")[0].toLowerCase();
  }, [price?.name, product?.category]);

  return form;
};
